// extracted by mini-css-extract-plugin
export default {"column__container":"styles_column__container__6OEdv"};